'use strict'
import { slider, slideritem }  from 'vue-concise-slider'// 引入slider组件
export default {
  name: 'company_product_introduction',
  data () {
	    return {
	        //图片列表[arr]
	        pages:[
		        {
		            title: '',
		            style:{
		            	background:'url(./static/lunbo/slideshow_0.png)'
		            }
		        },
		        {
		            title: '',
		            style:{
		            	background:'url(./static/lunbo/slideshow_1.png)'
		            }
		        },
		        {
		            title: '',
		            style:{
		              background:'url(./static/lunbo/slideshow_2.png)',
		              'background-repeat': 'no-repeat'
		            }
		        },
		        {
		            title: '',
		            style:{
		              background:'url(./static/lunbo/slideshow_3.png)',
		              'background-repeat': 'no-repeat'
		            }
		        },
		        {
		            title: '',
		            style:{
		              background:'url(./static/lunbo/slideshow_4.png)',
		              'background-repeat': 'no-repeat'
		            }
		        },
		        {
		            title: '',
		            style:{
		              background:'url(./static/lunbo/slideshow_5.png)',
		              'background-repeat': 'no-repeat'
		            }
		        }
	        ],
	        //滑动配置[obj]
	        sliderinit: {
	            currentPage: 0,//当前页码
	            thresholdDistance: 1000,//滑动判定距离
	            thresholdTime: 2000,//滑动判定时间
	            autoplay:15000,//自动滚动[ms]
	            loop:true,//循环滚动
	            direction:'horizontal',//方向设置，垂直滚动
	            infinite:1,//无限滚动前后遍历数
	            slidesToScroll:1,//每次滑动项数
	        }
	    }
	},
  components: {
	    slider,
      slideritem
	},
	methods: {
		
    //滑动到下一页
    slideNext () {
	    this.$refs.slider.$emit('slideNext')
	  },
	  //滑动到上一页
	  slidePre () {
	    this.$refs.slider.$emit('slidePre')
	  }
	}
}


// WEBPACK FOOTER //
// ./src/components/company_product_introduction/company_product_introduction.js